var map = {
	"./agents-modals.json": "./src/i18n/locales/en/agents-modals.json",
	"./agents-workflow.json": "./src/i18n/locales/en/agents-workflow.json",
	"./charts.json": "./src/i18n/locales/en/charts.json",
	"./common.json": "./src/i18n/locales/en/common.json",
	"./layout.json": "./src/i18n/locales/en/layout.json",
	"./page-agent-chat.json": "./src/i18n/locales/en/page-agent-chat.json",
	"./page-agent-insights-selection.json": "./src/i18n/locales/en/page-agent-insights-selection.json",
	"./page-api-endpoints.json": "./src/i18n/locales/en/page-api-endpoints.json",
	"./page-charts.json": "./src/i18n/locales/en/page-charts.json",
	"./page-database-connection.json": "./src/i18n/locales/en/page-database-connection.json",
	"./page-db-understanding-settings.json": "./src/i18n/locales/en/page-db-understanding-settings.json",
	"./page-insight-query.json": "./src/i18n/locales/en/page-insight-query.json",
	"./page-insights-results.json": "./src/i18n/locales/en/page-insights-results.json",
	"./page-plan-detail.json": "./src/i18n/locales/en/page-plan-detail.json",
	"./page-query-compare.json": "./src/i18n/locales/en/page-query-compare.json",
	"./page-query-execution.json": "./src/i18n/locales/en/page-query-execution.json",
	"./page-query-generator.json": "./src/i18n/locales/en/page-query-generator.json",
	"./page-report-generation.json": "./src/i18n/locales/en/page-report-generation.json",
	"./page-schema-analysis.json": "./src/i18n/locales/en/page-schema-analysis.json",
	"./page-settings.json": "./src/i18n/locales/en/page-settings.json",
	"./page-subagent-queries.json": "./src/i18n/locales/en/page-subagent-queries.json",
	"./pages-misc-1.json": "./src/i18n/locales/en/pages-misc-1.json",
	"./pages-misc-2.json": "./src/i18n/locales/en/pages-misc-2.json",
	"./pages-misc-3.json": "./src/i18n/locales/en/pages-misc-3.json",
	"./pages-misc-4.json": "./src/i18n/locales/en/pages-misc-4.json",
	"./pages-misc-5.json": "./src/i18n/locales/en/pages-misc-5.json",
	"./query-refinement.json": "./src/i18n/locales/en/query-refinement.json",
	"./report-design-chat.json": "./src/i18n/locales/en/report-design-chat.json",
	"./report-panels.json": "./src/i18n/locales/en/report-panels.json",
	"./shared-common.json": "./src/i18n/locales/en/shared-common.json",
	"./ui-common.json": "./src/i18n/locales/en/ui-common.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/i18n/locales/en sync \\.json$";